import { setCSSStyleDeclaration } from "../../../../../utils/helper";
import { ANCHOR } from "../../../utils/editorStyles.constants";
export const link = _ref => {
  let {
    hasInlineStyles
  } = _ref;
  return {
    attrs: {
      href: {},
      title: {
        default: null
      }
    },
    inclusive: false,
    parseDOM: [{
      tag: 'a[href]',
      getAttrs(dom) {
        return {
          href: dom.getAttribute('href'),
          title: dom.getAttribute('title')
        };
      }
    }],
    toDOM(node) {
      let {
        href,
        title
      } = node.attrs;
      const dom = document.createElement('a');
      if (hasInlineStyles) {
        setCSSStyleDeclaration(ANCHOR, dom);
      }
      dom.setAttribute('href', href);
      dom.setAttribute('title', title);
      return {
        dom,
        contentDOM: dom
      };
    }
  };
};